import { useEffect, useState } from 'react';

export function useFirstScreenReady(enabled: boolean): boolean {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setReady(false);
      return;
    }

    const root = document.getElementById('root');
    if (!root) return;
    const detectReadyScreen = () => {
      if (root.querySelector('[data-first-screen-ready="true"]')) setReady(true);
    };
    const observer = new MutationObserver(detectReadyScreen);
    observer.observe(root, { attributes: true, childList: true, subtree: true });
    detectReadyScreen();
    return () => observer.disconnect();
  }, [enabled]);

  return ready;
}
